import { Autocomplete, Stack, TextField, Typography } from '@mui/material'
import { FormikProps } from 'formik'
import { FC } from 'react'
import { DropdownOption } from 'shared/models/dropdownOption'
import { getPxAsRem } from 'shared/utils'
import { FormValues } from './blastValidationSchema'

interface JobBoardFormProps {
    formik: FormikProps<FormValues>
    titles: DropdownOption[]
    sectors: DropdownOption[]
    locations: DropdownOption[]
    startDate: string
}

const JobBoardForm: FC<JobBoardFormProps> = ({
    formik,
    titles,
    sectors,
    locations,
    startDate,
}) => {
    return (
        <Stack gap={getPxAsRem(24)} sx={{ marginTop: getPxAsRem(24) }}>
            <Typography variant="h5">Job Board</Typography>
            <TextField
                label="Name"
                helperText={formik.touched.name && <>{formik.errors.name}</>}
                error={formik.touched.name && Boolean(formik.errors.name)}
                onChange={(e) => formik.setFieldValue('name', e.target.value)}
                value={formik.values.name}
            />
            <TextField
                label="Description"
                value={formik.values.description}
                multiline
                rows={7}
                helperText={
                    formik.touched.description && (
                        <>{formik.errors.description}</>
                    )
                }
                error={
                    formik.touched.description &&
                    Boolean(formik.errors.description)
                }
                onChange={(e) =>
                    formik.setFieldValue('description', e.target.value)
                }
            />
            <Typography variant="h5">Details</Typography>
            <Autocomplete
                multiple
                getOptionLabel={(option) => option?.value || ''}
                isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Titles"
                        helperText={
                            formik.touched.titles && <>{formik.errors.titles}</>
                        }
                        error={
                            formik.touched.titles &&
                            Boolean(formik.errors.titles)
                        }
                    />
                )}
                options={titles}
                onChange={(e, value) => formik.setFieldValue('titles', value)}
                value={formik.values.titles}
            />
            <Autocomplete
                multiple
                getOptionLabel={(option) => option?.value || ''}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Sectors"
                        helperText={
                            formik.touched.sectors && (
                                <>{formik.errors.sectors}</>
                            )
                        }
                        error={
                            formik.touched.sectors &&
                            Boolean(formik.errors.sectors)
                        }
                    />
                )}
                options={sectors}
                isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                }
                onChange={(e, value) => formik.setFieldValue('sectors', value)}
                value={formik.values.sectors}
            />
            <Autocomplete
                multiple
                getOptionLabel={(option) => option?.value || ''}
                isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Locations"
                        helperText={
                            formik.touched.locations && (
                                <>{formik.errors.locations}</>
                            )
                        }
                        error={
                            formik.touched.locations &&
                            Boolean(formik.errors.locations)
                        }
                    />
                )}
                options={locations}
                value={formik.values.locations}
                onChange={(e, value) =>
                    formik.setFieldValue('locations', value)
                }
            />
            <TextField label="Start" value={startDate} disabled />
        </Stack>
    )
}

export default JobBoardForm
